module.exports = __webpack_public_path__ + "img/funight-kn95.86ba6536.jpg";